<template>
  <b-container>
    <b-card>
      <div class="table-header">
        <h2>Λίστα Διαχειριστών Εφαρμογής</h2>
        <b-button v-if="!toggleSAdminCreation" @click="toggleCreationForm" variant="outline-primary">Προσθήκη Κληρωτού Διαχειριστή</b-button>
        <b-button v-else @click="toggleCreationForm" variant="outline-danger">Ακύρωση</b-button>
      </div>
      <CreteSuperAdminForm v-if="toggleSAdminCreation" class="add-soldier-admin-card"/>
      <div class="search-filters-container">
        <div class="search-container">
          <b-form-input class="search-input" type="text" v-model="search" :placeholder="searchSelectionPlaceholder"/>
          <b-form-select v-model="selectedSearchAtr" :options="options" class="select-search-atr"></b-form-select>
        </div>
        <div class="filters-container">
          <b-form-select v-model="filters.adminTypeAtr" :options="filters.adminTypeOptions" class="select-search-atr"></b-form-select>
          <b-form-select v-model="filters.statusAtr" :options="filters.statusOptions" class="select-search-atr"></b-form-select>
        </div>
      </div>
      <b-row class="overflow-auto">
        <b-table id="admins-table"
                 :sort-desc.sync="sortDesc"
                 show-empty
                 hover
                 sort-icon-left
                 :items="superAdminsFilter"
                 :fields="tableColumns"
                 :current-page="currentPage"
                 :per-page="perPage">

          <template #cell(index)="data">
            {{ data.index + 1 }}
          </template>

          <template #cell(blocked)="data">
            {{ !data.value ? "Ενεργοποιημένος" : "Απενεργοποιημένος" }}
          </template>

          <template #cell(actions)="row">
            <div class="action-buttons">
              <b-button variant="outline-primary"
                        :id="'popover-trigger-' + row.index" style="">
                <b-icon icon="three-dots-vertical" class="icon"></b-icon>
              </b-button>
              <b-popover size="md" placement="auto" :target="'popover-trigger-' + row.index" triggers="click blur" title="Επιλογή Ενέργειας">
                <div class="actions-icons">
                  <b-button variant="warning" class="action-button" @click.prevent="showEditModal(row.item)">
                    Επεξεργασία
                    <b-icon icon="pencil" class="icon"/>
                  </b-button>
                  <b-button v-if="!row.item.blocked" variant="danger" class="action-button" @click="showDisableModal(row.item)">
                    Απενεργοποίηση
                    <b-icon icon="x-circle" class="icon"/>
                  </b-button>
                  <b-button v-else variant="success" class="action-button" @click="showEnableModal(row.item)">
                    Ενεργοποίηση
                    <b-icon icon="arrow-up-circle" class="icon"/>
                  </b-button>
                </div>
              </b-popover>
            </div>
          </template>

          <template #cell(idRole)="data">
            {{ getRole(data.value, data.item) }}
          </template>

          <template #empty="scope">
            <b-icon icon="search" />
            <p>{{ emptyTableText }}</p>
          </template>

        </b-table>
      </b-row>
      <b-pagination size="md" :total-rows="totalItems" v-model="currentPage"
                    :per-page="perPage" aria-controls="admins-table" class="pagination-bar"
                    first-number last-number></b-pagination>
    </b-card>

    <EditAdminModal :selectedAdmin="selectedAdmin"
                    :initModal="initModal"
                    :me_items="me_items"
                    @showToast="showToast"
                    @returnNewEmail="changeCurrentEmail"/>
    <ChangeAdminStatusModal :modalOptions="modalOptions"
                            :selectedAdmin="selectedAdmin"
                            @showToast="showToast"/>
    <Toast :toastOptions="toastOptions"/>
  </b-container>
</template>

<script>
import {HTTP} from "@/main";
import {tableColumns} from "@/config/superAdminTableCols"
import CreteSuperAdminForm from "@/components/super_admin/CreateSuperAdminForm"
import EditAdminModal from "@/components/super_admin/modals/EditAdminModal";
import ChangeAdminStatusModal from "@/components/super_admin/modals/ChangeAdminStatusModal";
import Toast from "@/components/super_admin/toast/Toast";

export default {
  name: "ManageSuperAdmins",
  components: {
    ChangeAdminStatusModal,
    EditAdminModal,
    CreteSuperAdminForm,
    Toast
  },
  data() {
    return {
      tableColumns: tableColumns,
      sortDesc: false,
      allAdmins: [],
      selectedAdmin: {},
      toggleSAdminCreation: false,
      totalItems: 0,
      currentPage: 1,
      perPage: 10,
      toastOptions: {},
      initModal: false,
      search: "",
      me_items: [],
      selectedSearchAtr: "επώνυμο",
      emptyTableText: "Δεν βρέθηκε καμία καταχώρηση με τα συγκεκριμένα χαρακτηριστικά.",
      options: [
        { value: 'επώνυμο', text: 'Επώνυμο' },
        { value: 'Α.Μ.', text: 'Α.Μ.' },
        { value: 'Α.Φ.Μ.', text: 'Α.Φ.Μ.' },
      ],
      filters: {
        adminTypeAtr: null,
        statusAtr: null,
        adminTypeOptions: [
          { value: null, text: '-- Είδος Διαχειριστή --' },
          { value: 'Διεύθυνση Επιστρατεύσεως - Εθνοφυλακής', text: 'Διεύθυνση Επιστρατεύσεως - Εθνοφυλακής' },
          { value: 'Υπερδιαχειριστής ΚΕΠΥΕΣ', text: 'Υπερδιαχειριστής ΚΕΠΥΕΣ' },
          { value: 'ΓΣΣ/ΔΕΠΣ', text: 'ΓΣΣ/ΔΕΠΣ' },
          { value: 'Δ\'ΣΣ/ΔΕΠΣ', text: 'Δ\'ΣΣ/ΔΕΠΣ' },
          { value: 'ΑΣΔΕΝ/ΔΕΠΕΘ', text: 'ΑΣΔΕΝ/ΔΕΠΕΘ' },
          { value: 'ΔΥΒ/ΔΕΠΣ', text: 'ΔΥΒ/ΔΕΠΣ' },
        ],
        statusOptions: [
          { value: null, text: '-- Κατάσταση --' },
          { value: 'Ενεργοποιημένος', text: 'Ενεργοποιημένος' },
          { value: 'Απενεργοποιημένος', text: 'Απενεργοποιημένος' },
        ]
      },
      modalOptions: {}
    }
  },
  methods: {
    fetchAdmins: function () {
      this.$store.dispatch('loading');
      let url = "/super-admin";
      HTTP.get(url)
          .then((response) => {
            this.allAdmins = []
            let resp = response.data;
            let data = resp.responseData;

            for (let i = 0; i < data.length; i++) {
              this.allAdmins.push(data[i]);
            }

            this.totalItems = this.allAdmins.length
          })
          .catch((e) => {
            console.error(e);
            this.$router.push({'name': 'login'});
          })
          .finally(() => this.$store.dispatch('stop_loading'));
    },
    toggleCreationForm: function () {
      this.toggleSAdminCreation = !this.toggleSAdminCreation
    },
    changePage: function () {
      this.fetchAdmins()
    },
    getRole: function (roleId, roleData) {

      switch (roleId) {
        case "1":
          return "Υπερδιαχειριστής ΚΕΠΥΕΣ"
        case "21":
          return "Διεύθυνση Επιστρατεύσεως - Εθνοφυλακής"
        case "22":
        case "23":
          return roleData.monaLek

      }
    },
    searchBySurname: function() {
      return this.allAdmins.filter(item => {
        let surname = item.epwnymo.toLowerCase().normalize("NFD").replace(/[\u0300-\u036f]/g, "")
        let searchWord = this.search.toLowerCase().normalize("NFD").replace(/[\u0300-\u036f]/g, "")

        return surname.startsWith(searchWord)
      })
    },
    searchByAm: function () {
      return this.allAdmins.filter(item => {
        return item.strkProsKwd.startsWith(this.search)
      })
    },
    searchByAfm: function () {
      return this.allAdmins.filter(item => {
        return item.afm.startsWith(this.search)
      })
    },
    filterByAdminType: function (array) {
      return array.filter(item => {

        let role = this.getRole(item.idRole, item)
        if(this.filters.adminTypeAtr !== null) {
          return this.filters.adminTypeAtr === role
        }
        else {
          return item
        }
      })
    },
    filterByStatus: function (array) {
      return array.filter(item => {
        const status = !item.blocked ? "Ενεργοποιημένος" : "Απενεργοποιημένος"

        if(this.filters.statusAtr !== null) {
          return this.filters.statusAtr === status
        }
        else {
          return item
        }
      })
    },
    showEditModal: function (item) {
      this.selectedAdmin = item
      this.initModal = true
      this.$bvModal.show('edit_modal');
    },
    showDisableModal: function (item) {
      this.selectedAdmin = item
      this.modalOptions = {
        header: "Απενεργοποίηση του Διαχειριστή με ΑΦΜ: " + item.afm,
        body: "Παρακαλούμε επιβεβαιώστε την απενεργοποίηση του χρήστη με Α.Φ.Μ.: " + item.afm + " και Α.Μ.: " + item.strkProsKwd + ".",
        text: "Απενεργοποίηση",
        id: "disable_modal"
      }
      this.$bvModal.show('change_admin_status_modal');
    },
    showEnableModal: function (item) {
      this.selectedAdmin = item
      this.modalOptions = {
        header: "Ενεργοποίηση του Διαχειριστή με ΑΦΜ: " + item.afm,
        body: "Παρακαλούμε επιβεβαιώστε την ενεργοποίηση του χρήστη με ΑΦΜ: " + item.afm + " και Α.Μ.: " + item.strkProsKwd + ".",
        text: "Ενεργοποίηση",
        id: "enable_modal"
      }
      this.$bvModal.show('change_admin_status_modal');
    },
    showToast: function (options) {
      this.toastOptions = options
      this.$bvToast.show('toast')
    },
    changeCurrentEmail: function (email) {
      this.selectedAdmin.email = email
    }
  },
  computed: {
    superAdminsFilter: function () {
      let filteredArray;

      switch (this.selectedSearchAtr) {
        case this.options[0].value:
          filteredArray = this.searchBySurname()
          break
        case this.options[1].value:
          filteredArray = this.searchByAm()
          break
        case this.options[2].value:
          filteredArray = this.searchByAfm()
          break;
      }

      filteredArray = this.filterByStatus(filteredArray)
      filteredArray = this.filterByAdminType(filteredArray)

      this.totalItems = filteredArray.length

      return filteredArray

    },
    searchSelectionPlaceholder: function () {
      return 'Αναζήτηση με βάση το ' + this.selectedSearchAtr
    }
  },
  beforeMount() {
    this.$store.dispatch('getMeMonadaItems')
      .then(response => {
          this.$store.dispatch("loading")
          let resp = response.data;
          this.me_items = resp.responseData.map((x) => {
            this.filters.adminTypeOptions.push({value: x.monaLek, text: x.monaLek})
            return {value: x, text: x.monaLek}
          })
        }
      ).finally(() => this.$store.dispatch("stop_loading"))
  },
  mounted() {
    this.fetchAdmins()
  }
}
</script>

<style scoped>
  .table-header, .search-filters-container {
    display: flex;
    justify-content: space-between;
    padding-top: 10px;
  }

  .table-header {
    padding-bottom: 10px;
  }

  .search-filters-container {
    padding-bottom: 20px;
  }

  .search-container {
    display: flex;
    width: 50%;
  }

  .icon {
    align-self: center;
  }

  .add-soldier-admin-card {
    margin-bottom: 20px;
  }

  #admins-table {
    font-size: 14px;
  }

  .select-search-atr {
    width: 25%;
  }

  .filters-container {
    display: flex;
    width: 40%;
    justify-content: space-between;
  }

  .filters-container select {
    width: 60%;
    margin-left: 10px;
  }

  .pagination {
    margin-top: 20px;
    justify-content: center;
  }

  .actions-icons {
    display: flex;
    flex-direction: column;
    margin-right: 10px;
  }

  .action-button {
    display: flex;
    justify-content: space-between;
    margin-top: 10px;
    width: 180px;
  }
</style>
